export enum DomainFeature {
  FINRA = 'FINRA'
}
